import script from "./CollectionEditCreatePage.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionEditCreatePage.vue?vue&type=script&setup=true&lang=js"

import "./CollectionEditCreatePage.vue?vue&type=style&index=0&id=6bdd879c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bdd879c"]])

export default __exports__